import styled from 'styled-components';

const TermsStyles = styled.div`
  max-width: 800px;
  margin: 0 auto;
  
  header {
    color: #000;
    padding: 24px 16px;
    text-align: center;
  }
  header h1 {
    font-size: 32px;
    font-weight: bold;
    margin: 0;
  }
  header p {
    font-size: 16px;
    margin-top: 8px;
  }
  main {
    max-width: 960px;
    margin: 32px auto;
    padding: 0 16px;
  }
  section {
    margin-bottom: 32px;
  }
  h2 {
    font-size: 24px;
    font-weight: bold;
    color: #1f2937;
    margin-bottom: 16px;
  }
  h3 {
    font-size: 20px;
    font-weight: 600;
    color: #1f2937;
    margin: 16px 0 8px;
  }
  p {
    font-size: 16px;
    color: #4b5563;
    line-height: 1.6;
    margin-bottom: 16px;
  }
  ul {
    list-style: disc;
    padding-left: 24px;
    margin-bottom: 16px;
  }
  li {
    font-size: 16px;
    color: #4b5563;
    margin-bottom: 8px;
  }
  a {
    color: #2563eb;
    text-decoration: none;
  }
  a:hover {
    text-decoration: underline;
  }
  strong {
    font-weight: bold;
  }
`;

export default TermsStyles;
